"use strict";

import Global from "/js/core/global.js";
import CardView from "/js/card-views/card-view.js";
import AppUtil from "/js/util/app-util.js";
import PrimerMaster from "/js/util/primermaster.js";

/**
 * Lesson tip card.
 */
export default class TipCardView extends CardView {
  
  static TEMPLATE_STRING = "\
      <img class='img' src='<%= image %>' alt=''>\
      <div class='caption <%=captionColorClass%>'><%= caption %></div>\
      <div class='text'><%= text %></div>\
      <div class='dot'></div>";
  static template = _.template(TipCardView.TEMPLATE_STRING);

  makeContent() {
    const o = {};
    o.image = AppUtil.makeLessonAssetPath(this.data.tipImage.url);
    o.caption = this.data.tipImage.caption;
    o.captionColorClass = PrimerMaster.getDarkColorClassForLessonId(Global.lessonId);
    o.text = CardView.makeHtmlFromJsonTextArray(this.data);
    return TipCardView.template(o);
  }
}
